import { render, staticRenderFns } from "./EditorSetting.vue.js?vue&type=template&id=ac510230!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditorSetting.vue?vue&type=template&id=ac510230"
import script from "./EditorSetting.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditorSetting.vue?vue&type=script&lang=js"
export * from "./EditorSetting.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports